import { Component, Input, input, InputSignal, output } from '@angular/core';
import { BusStopAppEntityBusStopWrite } from '../../../../../../../../openapi';
import { LabelComponent } from '../../../../../../../../common/label/label.component';
import { AccordionGroupComponent } from '../../../../../../../../common/accordion-group/accordion-group.component';
import { AccordionItemComponent } from '../../../../../../../../common/accordion-item/accordion-item.component';
import { BusStopLabelPipe } from '../../../../../../../../pipes/bus-stop-label.pipe';

@Component({
  selector: 'app-bus-stops-preview',
  standalone: true,
  imports: [
    LabelComponent,
    AccordionGroupComponent,
    AccordionItemComponent,
    BusStopLabelPipe
  ],
  templateUrl: './bus-stops-preview.component.html'
})
export class BusStopsPreviewComponent {

  @Input()
  public expanded: boolean = true;

  public showActions = input(false);

  public canEdit = input(true);

  public listOfStops: InputSignal<BusStopAppEntityBusStopWrite[]> = input<BusStopAppEntityBusStopWrite[]>([]);

  public onRemove = output<number>();

  public onEdit = output<{ v: BusStopAppEntityBusStopWrite, i: number }>();
}
